module.exports = __webpack_public_path__ + "static/media/websiteslook.321aee5b.png";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/websiteslook.png
// module id = 847
// module chunks = 7